import { memo } from "react";

import { FeatureIslandHeader } from "@/components/features/_layouts";

export const HPBHeader = memo(() => {
	const title = "ホームページビルダー";

	return <FeatureIslandHeader title={title} />;
});

HPBHeader.displayName = "HPBHeader";
